module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"appSend":"Send to App","orderSent":"Order sent to {driver}","failedToSend":"Failed sending order to {driver}"},"no":{"appSend":"Send til Confirm","orderSent":"Oppdrag sendt til {driver}","failedToSend":"Feilet ved sending av oppdrag til {driver}"}}')
  delete Component.options._Ctor
}
